import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthModal } from "@/components/AuthModal";

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [mode, setMode] = useState("register");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const open = (m) => { setMode(m); setAuthOpen(true); };

  return (
    <>
      <header
        data-testid="site-header"
        className={`fixed top-0 left-0 z-50 w-full border-b transition-colors duration-500 ${
          scrolled ? "border-white/10 bg-black/60 backdrop-blur-2xl" : "border-transparent"
        }`}
      >
        <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-5 md:px-12">
          <Link to="/" data-testid="logo-link" className="font-serif-lux text-2xl tracking-tight text-[#f5f5f0]">
            1of1
          </Link>
          <nav className="hidden items-center gap-10 text-[11px] uppercase tracking-[0.25em] text-[#a1a1aa] md:flex">
            <Link to="/marketplace" data-testid="nav-marketplace" className="transition-colors hover:text-[#f5f5f0]">
              The Collection
            </Link>
            <a href="/#manifesto" data-testid="nav-manifesto" className="transition-colors hover:text-[#f5f5f0]">
              Manifesto
            </a>
            <Link to="/consign" data-testid="nav-sell" className="transition-colors hover:text-[#f5f5f0]">
              Consign
            </Link>
            {user?.role === "admin" && (
              <Link to="/curator" data-testid="nav-curator" className="text-gold transition-colors hover:text-[#f5f5f0]">
                Curator
              </Link>
            )}
          </nav>
          <div className="flex items-center gap-5 text-[11px] uppercase tracking-[0.25em]">
            {user ? (
              <>
                <button data-testid="account-link" onClick={() => navigate("/account")} className="text-[#f5f5f0] hover:text-gold">
                  {user.name?.split(" ")[0] || "Account"}
                </button>
                <button data-testid="logout-btn" onClick={logout} className="text-[#a1a1aa] hover:text-[#f5f5f0]">
                  Exit
                </button>
              </>
            ) : (
              <>
                <button data-testid="header-login-btn" onClick={() => open("login")} className="text-[#a1a1aa] hover:text-[#f5f5f0]">
                  Sign in
                </button>
                <button
                  data-testid="header-register-btn"
                  onClick={() => open("register")}
                  className="hover-invert hidden rounded-none border border-white/30 px-5 py-2.5 text-[#f5f5f0] hover:bg-[#f5f5f0] hover:text-black sm:block"
                >
                  Request access
                </button>
              </>
            )}
          </div>
        </div>
      </header>
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} defaultMode={mode} />
    </>
  );
};
